<template>
    <Teleport v-if="isMounted && selectorExists(props.to)" :to="props.to"><slot></slot></Teleport>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue';

interface Props {
    to?: string;
}

const props = withDefaults(defineProps<Props>(), {
    to: 'body',
});

/**
 * Detect is mounted
 */
const isMounted = ref(false);
const selectorExists = (selector: string) => {
    return document.querySelector(selector) !== null;
};

onMounted(() => {
    isMounted.value = true;
});
</script>
